import { useState, useEffect } from 'react';
import i18n from '../../../../../../utils/i18n';

const IndustryExperienceManager = ({ providerData, onChange }) => {
	const [experienceLevels, setExperienceLevels] = useState({});

	useEffect(() => {
		const filteredIndustries = providerData.provider_industry_restrictions
			.filter((industry) => industry.on)
			.reduce((acc, industry) => {
				acc[industry.id] =
					providerData.provider_industry_experience[industry.id] || 1;
				return acc;
			}, {});

		setExperienceLevels(filteredIndustries);
	}, [providerData]);

	const handleExperienceChange = (industry, level) => {
		const updatedExperience = {
			...experienceLevels,
			[industry]: level,
		};

		setExperienceLevels(updatedExperience);

		if (onChange) {
			onChange(updatedExperience);
		}
	};

	return (
		<div>
			<div
				style={{
					display: 'grid',
					gridTemplateColumns: '240px 5fr',
					marginBottom: '10px',
				}}>
				<span></span>
				<div
					style={{
						display: 'grid',
						gridTemplateColumns: 'repeat(5, 1fr)',
						textAlign: 'center',
						maxWidth: '400px',
					}}>
					{[1, 2, 3, 4, 5].map((value) => (
						<span
							key={value}
							style={{ fontSize: '14px', fontWeight: 700, color: '#4b5080' }}>
							{value}
						</span>
					))}
				</div>
			</div>
			{Object.entries(experienceLevels).map(([industry, level]) => (
				<div
					key={industry}
					style={{
						display: 'grid',
						gridTemplateColumns: '240px 5fr',
						alignItems: 'center',
						marginBottom: '10px',
					}}>
					<span
						style={{
							fontSize: '14px',
							fontWeight: 700,
							color: '#4b5080',
							marginRight: '4px',
							whiteSpace: 'nowrap',
							overflow: 'hidden',
							textOverflow: 'ellipsis',
						}}>
						{i18n.t(`industrylabels.${industry}`)}
					</span>
					<div
						style={{
							display: 'grid',
							gridTemplateColumns: 'repeat(5, 1fr)',
							textAlign: 'center',
							maxWidth: '400px',
						}}>
						{[1, 2, 3, 4, 5].map((value) => (
							<label
								key={value}
								style={{ cursor: 'pointer', textAlign: 'center' }}>
								<input
									type='radio'
									name={industry}
									value={value}
									checked={level === value}
									onChange={() => handleExperienceChange(industry, value)}
									style={{ cursor: 'pointer', accentColor: '#1c32f3' }}
								/>
							</label>
						))}
					</div>
				</div>
			))}
		</div>
	);
};

export default IndustryExperienceManager;
